export const mapArrayForSelect = (array: string[]) => {
  return array.map(item => ({
    label: item,
    value: item
  }));
};
